import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "text-lg font-medium" }
const _hoisted_5 = { class: "text-sm text-muted -mb-1.25px" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "grid grid-cols-3 gap-x-6" }
const _hoisted_8 = { class: "text-muted text-xs text-center" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col -mt-12"
}
const _hoisted_10 = {
  style: {"font-size":"10rem"},
  class: "opacity-10 mx-auto"
}
const _hoisted_11 = {
  style: {"width":"10rem","height":"10rem"},
  viewBox: "0 0 24 24"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,10.84 21.79,9.69 21.39,8.61L19.79,10.21C19.93,10.8 20,11.4 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.6,4 13.2,4.07 13.79,4.21L15.4,2.6C14.31,2.21 13.16,2 12,2M19,2L15,6V7.5L12.45,10.05C12.3,10 12.15,10 12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12C14,11.85 14,11.7 13.95,11.55L16.5,9H18L22,5H19V2M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12H16A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8V6Z"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "mx-auto opacity-40 -mt-4" }
const _hoisted_15 = { class: "flex items-center ml-1 mt-6 pt-6 border-t border-gray-200 space-x-4" }
const _hoisted_16 = { class: "flex items-center space-x-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "material-icons mr-1.5 text-primary" }, "auto_awesome", -1)
const _hoisted_18 = { class: "font-semibold text-lg" }
const _hoisted_19 = { class: "flex items-center space-x-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "material-icons-outlined text-primary" }, "leaderboard", -1)
const _hoisted_21 = { class: "text-lg" }
const _hoisted_22 = {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "ml-4 flex items-center flex-wrap space-x-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircularProgress = _resolveComponent("CircularProgress")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_GamificationBadge = _resolveComponent("GamificationBadge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("gamification.goals")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGoals, (goal) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mb-6",
        key: 'goal-' + goal.id
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(goal.name), 1),
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t("gamification.current_level")) + ": ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.mainStore.progressByGoalId[goal.id]?.current_level ?? 0), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("gamification.to_reach_next_level")) + ":", 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNextLevel(goal)?.requirements ?? [], (requirement, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col items-center whitespace-normal space-y-1",
                key: 'goal-' + goal.id + '-req-' + index
              }, [
                (!_ctx.loadingProgressByGoalId[goal.id])
                  ? (_openBlock(), _createBlock(_component_CircularProgress, {
                      key: 0,
                      size: 'sm',
                      value: _ctx.getActionCount(goal, requirement.action),
                      total: requirement.amount
                    }, null, 8, ["value", "total"]))
                  : (_openBlock(), _createBlock(_component_Spinner, {
                      key: 1,
                      size: 'lg'
                    })),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("gamification.actions." + requirement.action)) + " ", 1)
              ]))
            }), 128))
          ])
        ])
      ]))
    }), 128)),
    (_ctx.sortedGoals.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, [
            (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
          ]),
          _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.$t("gamification.no_goals")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_Tooltip, {
        placement: 'top',
        textValue: _ctx.$t('gamification.your_reputation')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.mainStore.gamificationContext?.reputation ?? 0), 1)
          ])
        ]),
        _: 1
      }, 8, ["textValue"]),
      (
					_ctx.mainStore.gamificationContext &&
					_ctx.mainStore.gamificationContext.leaderboard_position !== null
				)
        ? (_openBlock(), _createBlock(_component_Tooltip, {
            key: 0,
            placement: 'top',
            textValue: _ctx.$t('gamification.your_leaderboard_position')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.mainStore.gamificationContext.leaderboard_position), 1),
                (_ctx.mainStore.gamificationContext.leaderboard_position <= 3)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass({
							'text-yellow-400': _ctx.mainStore.gamificationContext.leaderboard_position === 1,
							'text-gray-400': _ctx.mainStore.gamificationContext.leaderboard_position === 2,
							'text-yellow-900': _ctx.mainStore.gamificationContext.leaderboard_position === 3,
						})
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["textValue"]))
        : _createCommentVNode("", true),
      true
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createVNode(_component_GamificationBadge, { class: "text-primary" }),
            _createVNode(_component_GamificationBadge, { class: "text-primary" }),
            _createVNode(_component_GamificationBadge, { class: "text-primary-light" }),
            _createVNode(_component_GamificationBadge, { class: "text-primary-dark" }),
            _createVNode(_component_GamificationBadge, { class: "text-gray-500" }),
            _createVNode(_component_GamificationBadge, { class: "text-success" })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}